/* tslint:disable */
/* eslint-disable */
/**
 * MsgToDb
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GeneralError } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
// @ts-ignore
import type { Software } from '../models';
// @ts-ignore
import type { UserClient } from '../models';
/**
 * SoftwaresApi - axios parameter creator
 * @export
 */
export const SoftwaresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftware: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSoftware', 'id', id)
            const localVarPath = `/api/Softwares/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftware: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSoftware', 'id', id)
            const localVarPath = `/api/Softwares/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} softwareId 
         * @param {string} imageType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareImage: async (softwareId: string, imageType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'softwareId' is not null or undefined
            assertParamExists('getSoftwareImage', 'softwareId', softwareId)
            // verify required parameter 'imageType' is not null or undefined
            assertParamExists('getSoftwareImage', 'imageType', imageType)
            const localVarPath = `/api/Softwares/images/{imageType}/{softwareId}`
                .replace(`{${"softwareId"}}`, encodeURIComponent(String(softwareId)))
                .replace(`{${"imageType"}}`, encodeURIComponent(String(imageType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} softwareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareUsers: async (softwareId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'softwareId' is not null or undefined
            assertParamExists('getSoftwareUsers', 'softwareId', softwareId)
            const localVarPath = `/api/Softwares/{softwareId}/users`
                .replace(`{${"softwareId"}}`, encodeURIComponent(String(softwareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwares: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Softwares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Software} [software] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSoftware: async (software?: Software, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Softwares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(software, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Software} [software] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSoftware: async (id: number, software?: Software, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putSoftware', 'id', id)
            const localVarPath = `/api/Softwares/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(software, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} imageType 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSoftwareImage: async (id: number, imageType: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putSoftwareImage', 'id', id)
            // verify required parameter 'imageType' is not null or undefined
            assertParamExists('putSoftwareImage', 'imageType', imageType)
            const localVarPath = `/api/Softwares/images/{imageType}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"imageType"}}`, encodeURIComponent(String(imageType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} softwareId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSoftwareUsers: async (softwareId: number, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'softwareId' is not null or undefined
            assertParamExists('putSoftwareUsers', 'softwareId', softwareId)
            const localVarPath = `/api/Softwares/{softwareId}/users`
                .replace(`{${"softwareId"}}`, encodeURIComponent(String(softwareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SoftwaresApi - functional programming interface
 * @export
 */
export const SoftwaresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SoftwaresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSoftware(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSoftware(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.deleteSoftware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftware(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Software>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftware(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.getSoftware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} softwareId 
         * @param {string} imageType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareImage(softwareId: string, imageType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareImage(softwareId, imageType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.getSoftwareImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} softwareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareUsers(softwareId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserClient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareUsers(softwareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.getSoftwareUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwares(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Software>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwares(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.getSoftwares']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Software} [software] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSoftware(software?: Software, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Software>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSoftware(software, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.postSoftware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Software} [software] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSoftware(id: number, software?: Software, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSoftware(id, software, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.putSoftware']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} imageType 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSoftwareImage(id: number, imageType: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Software>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSoftwareImage(id, imageType, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.putSoftwareImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} softwareId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSoftwareUsers(softwareId: number, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSoftwareUsers(softwareId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwaresApi.putSoftwareUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SoftwaresApi - factory interface
 * @export
 */
export const SoftwaresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SoftwaresApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftware(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSoftware(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftware(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Software> {
            return localVarFp.getSoftware(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} softwareId 
         * @param {string} imageType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareImage(softwareId: string, imageType: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getSoftwareImage(softwareId, imageType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} softwareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareUsers(softwareId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserClient>> {
            return localVarFp.getSoftwareUsers(softwareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwares(options?: RawAxiosRequestConfig): AxiosPromise<Array<Software>> {
            return localVarFp.getSoftwares(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Software} [software] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSoftware(software?: Software, options?: RawAxiosRequestConfig): AxiosPromise<Software> {
            return localVarFp.postSoftware(software, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {Software} [software] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSoftware(id: number, software?: Software, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putSoftware(id, software, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} imageType 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSoftwareImage(id: number, imageType: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<Software> {
            return localVarFp.putSoftwareImage(id, imageType, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} softwareId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSoftwareUsers(softwareId: number, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putSoftwareUsers(softwareId, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SoftwaresApi - object-oriented interface
 * @export
 * @class SoftwaresApi
 * @extends {BaseAPI}
 */
export class SoftwaresApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public deleteSoftware(id: number, options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).deleteSoftware(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public getSoftware(id: number, options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).getSoftware(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} softwareId 
     * @param {string} imageType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public getSoftwareImage(softwareId: string, imageType: string, options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).getSoftwareImage(softwareId, imageType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} softwareId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public getSoftwareUsers(softwareId: number, options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).getSoftwareUsers(softwareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public getSoftwares(options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).getSoftwares(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Software} [software] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public postSoftware(software?: Software, options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).postSoftware(software, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {Software} [software] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public putSoftware(id: number, software?: Software, options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).putSoftware(id, software, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} imageType 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public putSoftwareImage(id: number, imageType: string, file?: File, options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).putSoftwareImage(id, imageType, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} softwareId 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public putSoftwareUsers(softwareId: number, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).putSoftwareUsers(softwareId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

